import React, { useState } from 'react';
import { ModalShell, ModalActions } from './modals/core';

interface Props {
  guests: Array<{ mg_nr: string; vorname: string; name: string; archive?: { remaining_entries: number } }>;
  archived: boolean;
  onClose: () => void;
  onSave: (reason: string, confirmed: boolean) => Promise<void>;
}
export default function GuestArchiveDialog({ guests, archived, onClose, onSave }: Props) {
  const [reason, setReason] = useState('');
  const [confirmed, setConfirmed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const creditGuests = guests.filter(guest => (guest.archive?.remaining_entries || 0) > 0);
  const needsConfirmation = archived && creditGuests.length > 0;
  const save = async () => {
    setBusy(true); setError('');
    try { await onSave(reason, confirmed); onClose(); }
    catch (err: any) { setError(err.response?.data?.message || 'Speichern fehlgeschlagen. Bitte erneut versuchen.'); }
    finally { setBusy(false); }
  };
  return <ModalShell open variant="form" onClose={() => { if (!busy) onClose(); }} title={archived ? 'Gäste archivieren' : 'Gäste reaktivieren'}>
    <div className="space-y-4 text-sm text-gray-700 dark:text-gray-200">
      <p>{guests.length} {guests.length === 1 ? 'Gast wird' : 'Gäste werden'} {archived ? 'aus der aktiven Gästeliste ins Archiv verschoben.' : 'wieder in der aktiven Gästeliste angezeigt.'}</p>
      <ul className="max-h-40 overflow-y-auto rounded-xl border border-gray-200 p-3 dark:border-gray-700">
        {guests.map(guest => <li key={guest.mg_nr} className="py-1">{guest.vorname} {guest.name}{archived && !!guest.archive?.remaining_entries && ` · ${guest.archive.remaining_entries} Resttickets`}</li>)}
      </ul>
      <p>Karten, Zahlungen und Buchungen bleiben erhalten. Login und Mitgliedschaft bleiben unverändert. Ein neuer Kartenkauf oder eine neue Terminbuchung reaktiviert den Gast automatisch.</p>
      {archived && <label className="block font-medium">Begründung (optional)
        <textarea value={reason} maxLength={500} onChange={event => setReason(event.target.value)} rows={2} className="mt-2 w-full rounded-xl border border-gray-300 bg-white p-3 text-gray-900 dark:border-gray-600 dark:bg-gray-800 dark:text-white" />
      </label>}
      {needsConfirmation && <label className="flex min-h-[44px] cursor-pointer items-start gap-3 rounded-xl border border-warning-300 bg-warning-50 p-3 text-warning-800 dark:border-warning-700 dark:bg-warning-900/20 dark:text-warning-200">
        <input type="checkbox" checked={confirmed} onChange={event => setConfirmed(event.target.checked)} className="mt-1 h-5 w-5 shrink-0" />
        <span>Ich habe die Resttickets von {creditGuests.length} {creditGuests.length === 1 ? 'Gast' : 'Gästen'} geprüft und möchte trotzdem archivieren. Die Tickets bleiben erhalten.</span>
      </label>}
      {error && <p role="alert" className="text-error-600 dark:text-error-400">{error}</p>}
      <ModalActions
        secondary={{ label: 'Abbrechen', disabled: busy, onClick: onClose }}
        primary={{ label: archived ? 'Archivieren' : 'Reaktivieren', loading: busy, disabled: busy || (needsConfirmation && !confirmed), onClick: save }}
      />
    </div>
  </ModalShell>;
}
